module.exports = __webpack_public_path__ + "405ad791124e4b8b319f5c18cc3537ff.pdf";